export const getRunStateTransitionId = (timestamp: number, stateVersion: number | null) => {
  return `${timestamp}-${stateVersion}`;
};
